import { apiConfig } from "@/api/AppApi/config";
import ApiTimeSlots from "./api-time-slots";
import {
  IGetTimeSlotsDetailsParams,
  IGetTimeSlotsParams,
} from "./interfaces/api-time-slots-interfces";
import { useQuery } from "@tanstack/react-query";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";

export const dateFormat = "YYYY-MM-DD";

export const useTimeSlots = () => new ApiTimeSlots(apiConfig());

export const useGetTimeSlots = (params: IGetTimeSlotsParams) => {
  const timeSlots = useTimeSlots();
  return useQuery(
    [...getKey(Keys.get_time_slots), Object.values(params)],
    () => timeSlots.getTimeSlots(params),
    {
      refetchOnWindowFocus: true,
      enabled: !!params.product_id,
    }
  );
};

export const useGetTimeSlotsSpecific = (params: IGetTimeSlotsDetailsParams) => {
  const timeSlots = useTimeSlots();
  return useQuery(
    [...getKey(Keys.get_time_slots_specific), Object.values(params)],
    () => timeSlots.getTimeSlotsSpecific(params),
    {
      refetchOnWindowFocus: true,
      enabled: !!params.date,
    }
  );
};
